import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Input from "../Components/shared/Input";

const FollowUpModal = ({
  show,
  onClose,
  onConfirm,
  followUpDate,
  setFollowUpDate,
}) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (show) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 300); // same as your CSS animation duration
      return () => clearTimeout(timer);
    }
  }, [show]);

    const handleCancel = () => {
    onClose?.();             // Close the modal
    window.location.reload(); // Reload the page
  };
  return (
    <div
      className={`modal ${show ? "d-block" : "d-none"}`}
      tabIndex="-1"
      role="dialog"
      style={{
        pointerEvents: show ? "auto" : "none",
        backdropFilter: "blur(4px)",
      }}
    >
      <div
        className={`modal-dialog modal-dialog-centered ${
          animate ? "animate-slide" : ""
        }`}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header mb-3">
            <h5 className="modal-title">Set Follow Up Date & Time</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleCancel}
            ></button>
          </div>
          <div className="modal-body mb-3">
            <Input
              label="Follow Up Date & Time"
              name="follow_up_datetime"
              type="datetime-local"
              value={followUpDate}
              onChange={(name, value) => setFollowUpDate(value)}
              placeholder="Select date & time"
              icon="feather-date"
              required={true}
             
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUpModal;
